module.exports = __webpack_public_path__ + "img/google-dark.17708cb2.png";